import React from 'react';
import { VyTooltip, type VyTooltipProps } from '../VyTooltip';

type VyHintProps = Omit<VyTooltipProps, 'children'>;

export const VyHint: React.FC<VyHintProps> = ({ tooltipContent, ...props }) => {
  return (
    <VyTooltip tooltipContent={tooltipContent} placement="top" {...props}>
      <span className="flex bg-[#0D1B274D] cursor-pointer rounded-full w-5 h-5 text-white font-medium select-none text-sm justify-center items-center">
        ?
      </span>
    </VyTooltip>
  );
};
